/*
  Daryada — panneau de recherche.
  Ouverture depuis la loupe de l'en-tête ; résultats en direct à partir de
  2 caractères (recherche prédictive native de Shopify). Sans JavaScript,
  la loupe mène simplement à la page de recherche.
*/
(() => {
  const panel = document.querySelector('[data-recherche]');
  const opener = document.querySelector('[data-recherche-ouvrir]');
  if (!panel || !opener) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const input = panel.querySelector('[data-recherche-champ]');
  const results = panel.querySelector('[data-recherche-resultats]');
  const suggestions = panel.querySelector('[data-recherche-suggestions]');

  const open = () => {
    // Mobile : si le menu plein écran est ouvert, il se referme et laisse place au panneau
    const menuToggle = document.querySelector('[data-menu-toggle][aria-expanded="true"]');
    if (menuToggle) menuToggle.click();
    panel.hidden = false;
    opener.setAttribute('aria-expanded', 'true');
    input.focus();
  };

  const close = (restoreFocus = true) => {
    if (panel.hidden) return;
    panel.hidden = true;
    opener.setAttribute('aria-expanded', 'false');
    if (restoreFocus) opener.focus();
  };

  opener.addEventListener('click', (event) => {
    event.preventDefault();
    if (panel.hidden) open();
    else close();
  });

  panel.querySelector('[data-recherche-fermer]').addEventListener('click', () => close());

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) close();
  });

  document.addEventListener('click', (event) => {
    if (panel.hidden) return;
    if (!panel.contains(event.target) && !opener.contains(event.target)) close(false);
  });

  /* Résultats en direct ----------------------------------------------- */
  let timer = null;
  let controller = null;

  const search = async (terms) => {
    if (controller) controller.abort();
    controller = new AbortController();
    const params = new URLSearchParams({
      q: terms,
      'resources[type]': 'product',
      'resources[limit]': '6',
      'resources[options][unavailable_products]': 'last',
      section_id: 'predictive-search',
    });
    try {
      const response = await fetch(`${root}search/suggest?${params}`, { signal: controller.signal });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = html.querySelector('[data-predictive]');
      results.innerHTML = fresh ? fresh.innerHTML : '';
      suggestions.hidden = true;
    } catch (error) {
      // Recherche interrompue par une nouvelle frappe : rien à faire
    }
  };

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const terms = input.value.trim();
    if (terms.length < 2) {
      if (controller) controller.abort();
      results.innerHTML = '';
      suggestions.hidden = false;
      return;
    }
    timer = setTimeout(() => search(terms), 250);
  });
})();
